import React from 'react';
import BugReportIcon from '@mui/icons-material/BugReport';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import StarIcon from '@mui/icons-material/Star';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';

/**
 * Issue/task types selectable on a task (Jira-like). Used in create/edit dialogs
 * and rendered on the task card.
 */
export const TASK_TYPES = [
  { value: 'task', label: 'Aufgabe', color: '#1e3a5f' },
  { value: 'bug', label: 'Bug', color: '#e01e26' },
  { value: 'feature', label: 'Feature', color: '#10b981' },
  { value: 'question', label: 'Frage', color: '#00acc1' },
];

export const getTaskType = (value) =>
  TASK_TYPES.find((t) => t.value === value) || TASK_TYPES[0];

export const taskTypeIcon = (value, props = {}) => {
  switch (value) {
    case 'bug':
      return <BugReportIcon {...props} />;
    case 'feature':
      return <StarIcon {...props} />;
    case 'question':
      return <QuestionAnswerIcon {...props} />;
    default:
      return <TaskAltIcon {...props} />;
  }
};
